module.exports = __webpack_public_path__ + "static/media/rottentomatoes.565e4489.svg";